import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { ProductOrderMatch } from '../../../data/receiving';
import { emDashIfEmpty, productHeadColumns, productTailColumns } from './product-columns';

const matchProduct = (m: ProductOrderMatch) => m.product;

const MATCHED_COLUMNS = [
  ...productHeadColumns<ProductOrderMatch>(matchProduct),
  defineColumn<ProductOrderMatch>({
    id: 'Item code',
    minWidth: 100,
    maxWidth: 160,
    accessorFn: (m) => emDashIfEmpty(m.product.item_code || m.product.raw_item_code),
    cell: ({ value }) => <span className="font-mono">{value}</span>,
  }),
  ...productTailColumns<ProductOrderMatch>(matchProduct),
];

export function MatchedProductsTable({ rows }: { rows: ProductOrderMatch[] }) {
  return <TanStackTable data={rows} columns={MATCHED_COLUMNS} />;
}
